import axios from 'axios'
import qs from 'qs'
import { AUTH_TOKEN_KEY } from '../app/contants'

const API_URL = process.env.REACT_APP_API_URL

const request = (method, url, options) =>
  axios({
    method,
    url,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
      'Content-Type': 'application/json',
    },
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        encodeValuesOnly: true,
      })
    },
    ...options,
  })
    .then((data) => data || {})
    .catch((err) => {
      if (err.response?.status === 401) {
        localStorage.removeItem(AUTH_TOKEN_KEY)
        //history.push('/login')
      }
      throw err
    })

export const get = (path, params, options) => request('get', `${API_URL}/${path}`, { params, ...options })
export const post = (path, options) => request('post', `${API_URL}/${path}`, options)
export const put = (path, data) => request('put', `${API_URL}/${path}`, { data })
export const patch = (path, data) => request('patch', `${API_URL}/${path}`, { data })
export const del = (path, data) => request('delete', `${API_URL}/${path}`, { data })

export default request
